import React from 'react'
import { COUNTRY, GLOBAL_SETTINGS_FONTSIZE_VALUES } from '../../../utils/constants'
import {
  anchorageOptionData,
  compressiveStrengthData,
  geometrySubTypeData,
  geometryTypeData,
  lumberSpeciesData,
  materialTypeData,
  postBaseFastenersTypeData,
  postBaseMaterialTypeData,
  postThicknessData,
  postWidthData,
} from './json/staticData.json'

export const APP_CONFIG = {
  appCode: 'PFD',
  appVersion: '2.2.1',
  appName: 'Post-to-Foundation Designer',
  logoUrl: 'assets/images/pfd/pfd-logo.svg',
  gaEventName: 'PFD_Events',
  downloadFileName: 'PFD-DATA',
  productThemeClasses: '-themeConnectors',
  navigationConfig: {
    showTutorial: true,
  },
}

export const APP_STATE_KEY = `sst_bp_${APP_CONFIG.appCode}_app-state`

export const GLOBAL_SETTINGS_FONTSIZE_OPTIONS = [
  {
    label: 'Compact',
    value: GLOBAL_SETTINGS_FONTSIZE_VALUES.COMPACT,
  },
  {
    label: 'Default',
    value: GLOBAL_SETTINGS_FONTSIZE_VALUES.DEFAULT,
  },
]

export const INPUT_NAME = {
  HOLDOWN_TYPE: 'holdownType',
  POST_BASE_TYPE: 'postBaseType',
  POST_BASE_DESIGN: 'postBaseDesign',
  HOLDOWN_DESIGN: 'holdownDesign',
  FOUNDATION_DESIGN: 'foundationDesign',
  UPLIFT_LOAD_ASD: 'upliftLoadASD',
  DOWNLOAD_ASD: 'downloadASD',
  LATERAL_F1: 'lateralF1',
  LATERAL_F2: 'lateralF2',
  LOAD_TYPE: 'loadType',
  POST_BASE_LOAD_TYPE: 'postBaseLoadType',
  UPLIFT_DURATION: 'upliftDuration',
  FACTORED_UPLIFT_LRFD: 'factoredUpliftLRFD',
  DOWNLOAD_DURATION: 'downloadDuration',
  FACTORED_DOWNLOAD_LRFD: 'factoredDownloadLRFD',
  CORROSION_RESISTANCE: 'corrosionResistance',
  MIN_STEMWALL_THICKNESS: 'minStemwallThickness',
  HOLDOWN_FASTENERS_TYPE: 'holdownFastenersType',
  LUMBER_SPECIES: 'lumberSpecies',
  WALL_THICKNESS: 'wallThickness',
  INSTALL_OVER_SHEATHING: 'installOverSheathing',
  POST_THICKNESS: 'postThickness',
  POST_WIDTH: 'postWidth',
  INSTALLATION_TYPE: 'installationType',
  MATERIAL_TYPE: 'materialType',
  COMPRESSIVE_STRENGTH: 'compressiveStrength',
  ANCHORAGE_OPTION: 'anchorageOption',
  RAISED_FLOOR: 'raisedFloor',
  GEOMETRY_TYPE: 'geometryType',
  GEOMETRY_SUBTYPE: 'geometrySubType',
  POST_BASE_FASTENERS_TYPE: 'postBaseFastenersType',
  POST_BASE_LUMBER_SPECIES: 'postBaseLumberSpecies',
  POST_BASE_MATERIAL_TYPE: 'postBaseMaterialType',
  POST_BASE_GEOMETRY_SUBTYPE: 'postBaseGeometrySubType',
  FOUNDATION_TYPE: 'foundationType',
  HOLDOWN_SUBTYPE: 'holdownSubType',
  POST_BASE_SUBTYPE: 'postBaseSubType',
}

export const MEASUREMENT_UNITS = {
  LBS: 'lbs',
}

export const HOLDOWN_TYPE = {
  POST_INSTALLED: '1',
  CAST_IN_PLACE: '2',
}

export const HOLDOWN_SUBTYPE = {
  EMBEDDED_ANCHOR: '0',
  EMBEDDED_STRAP: '1',
}

export const HOLDOWN_FASTENERS = {
  ALL: '0,1,3',
  SCREWS: '0',
  BOLTS: '1',
  NAILS: '3',
}

export const MATERIAL_TYPE = {
  CMU: 'cmu',
  CONCRETE: 'concrete',
}

export const ANCHORAGE_OPTION = {
  CAST_IN_PLACE: '0',
  ADHESIVE: '1',
  MECHANICAL: '2',
}

export const GEOMETRY_TYPE = {
  ELEVATED_SLAB: '0',
  INTERIOR_THICKENED_FOOTING: '1',
  STEMWALL: '2',
  TURNED_DOWN_SLAB: '3',
  BRICK_LEDGE: '4',
  GARAGE_SLAB: '5',
  GARAGE_STEMWALL: '6',
}

export const GEOMETRY_SUBTYPE = {
  MIDWALL_ANCHOR: '1',
}

export const POST_BASE_SUBTYPE = {
  POST_INSTALLED: '0',
  CAST_IN_PLACE: '1',
}

export const POST_BASE_TYPE = {
  POST_INSTALLED: '1',
  CAST_IN_PLACE: '2',
}

export const POST_BASE_MATERIAL_TYPE = {
  CONCRETE: 'concrete',
  WOOD: 'wood',
}

export const POST_BASE_FASTENERS_TYPE = {
  ALL: '0,1,2,3',
  SCREWS: '0',
  BOLTS: '1',
  DOWELS: '2',
  NAILS: '3',
}

export const POST_BASE_LUMBER_SPECIES = {
  [COUNTRY.USA]: {
    DOUGLAS_FIR_LARCH: '0',
    SOUTHERN_PINE: '1',
    SPRUCE_PINE_FIR: '2',
    HEM_FIR: '3',
    STRUCTURAL_COMPOSITE_LUMBER: '4',
    GLULAM: '5',
  },
  [COUNTRY.CANADA]: {
    DOUGLAS_FIR_LARCH: '0',
    SPRUCE_PINE_FIR: '1',
    DOUGLAS_FIR_LARCH_ROUGH: '2',
    SPRUCE_PINE_FIR_ROUGH: '3',
    LSL: '4',
    LVL: '5',
    PSL: '6',
    GLULAM_DF: '7',
    GLULAM_SPF: '8',
  },
}

export const DESIGN_CODE = {
  IBC2015: '21',
  IBC2018: '22',
  IBC2012: '20',
}

export const LUMBER_SPECIES = {
  DOUGLAS_FIR_LARCH: '1',
  SOUTHERN_PINE: '3',
  SPRUCE_PINE_FIR: '4',
  HEM_FIR: '2',
  STRUCTURAL_COMPOSITE_LUMBER: '61',
}

export const WALL_THICKNESS = {
  INCH4: '3.5',
  INCH6: '5.5',
  INCH8: '7.25',
}

export const COMPRESSIVE_STRENGTH = {
  PSI2500: '0',
  PSI3000: '1',
  PSI4000: '3',
}

export const POST_BASE_GEOMETRY_TYPE = {
  STEMWALL: '0',
  SLAB: '1',
}

export const POST_BASE_GEOMETRY_SUBTYPE = {
  EDGE_WALL_ANCHOR: '0',
  MID_WALL_ANCHOR: '1',
  CORNER_ANCHOR: '2',
}

export const CORROSION_RESISTANCE_VALUE = {
  ALL: '0,1,2',
  LOW: '0',
  MEDIUM: '1',
  HIGH: '2',
}

export const POST_BASE_LOAD_TYPE = {
  WIND_AND_SDC_AB: '0',
  WIND_AND_SDC_AB_CRACKED: '1',
  SEISMIC_AND_SDC_CF: '2',
  SEISMIC_AND_SDC_CF_CRACKED: '3',
}

export const materialTypeOptions = {
  [HOLDOWN_SUBTYPE.EMBEDDED_ANCHOR]: materialTypeData.holdownSubType.embeddedAnchorOptions,
  [HOLDOWN_SUBTYPE.EMBEDDED_STRAP]: materialTypeData.holdownSubType.embeddedStrapOptions,
}

export const anchorageOptions = {
  [MATERIAL_TYPE.CMU]: anchorageOptionData.materialType.cmuOptions,
  [MATERIAL_TYPE.CONCRETE]: anchorageOptionData.materialType.concreteOptions,
}

export const postBaseFastenersTypeOptions = {
  [POST_BASE_SUBTYPE.POST_INSTALLED]:
    postBaseFastenersTypeData.postBaseSubType.postInstalledOptions,
  [POST_BASE_SUBTYPE.CAST_IN_PLACE]: postBaseFastenersTypeData.postBaseSubType.castInPlaceOptions,
}

export const holdownLumberSpeciesOptions = {
  [COUNTRY.USA]: lumberSpeciesData.usa.holdownOptions,
  [COUNTRY.CANADA]: {
    [HOLDOWN_TYPE.POST_INSTALLED]: lumberSpeciesData.canada.holdown.postInstalledOptions,
    [HOLDOWN_TYPE.CAST_IN_PLACE]: lumberSpeciesData.canada.holdown.castInPlaceOptions,
  },
}

export const postBaseLumberSpeciesOptions = {
  [COUNTRY.USA]: {
    [POST_BASE_SUBTYPE.POST_INSTALLED]: lumberSpeciesData.usa.postBase.postInstalledOptions,
    [POST_BASE_SUBTYPE.CAST_IN_PLACE]: lumberSpeciesData.usa.postBase.castInPlaceOptions,
  },
  [COUNTRY.CANADA]: {
    [POST_BASE_TYPE.POST_INSTALLED]: lumberSpeciesData.canada.postBase.postInstalledOptions,
    [POST_BASE_TYPE.CAST_IN_PLACE]: lumberSpeciesData.canada.postBase.castInPlaceOptions,
  },
}

export const postBaseMaterialTypeOptions = {
  [POST_BASE_SUBTYPE.POST_INSTALLED]: postBaseMaterialTypeData.postBaseSubType.postInstalledOptions,
  [POST_BASE_SUBTYPE.CAST_IN_PLACE]: postBaseMaterialTypeData.postBaseSubType.castInPlaceOptions,
}

export const POST_BASE_SUBTYPE_LABEL = {
  [POST_BASE_SUBTYPE.POST_INSTALLED]: 'Post-Installed',
  [POST_BASE_SUBTYPE.CAST_IN_PLACE]: 'Cast-In-Place',
}

export const compressiveStrengthOptions = {
  [HOLDOWN_SUBTYPE.EMBEDDED_ANCHOR]: compressiveStrengthData.options,
  [HOLDOWN_SUBTYPE.EMBEDDED_STRAP]: compressiveStrengthData.optionsB,
}

export const geometryTypeOptions = {
  [HOLDOWN_SUBTYPE.EMBEDDED_STRAP]: geometryTypeData.holdownSubType.embeddedStrapOptions,
  [MATERIAL_TYPE.CMU]: geometryTypeData.materialType.cmuOptions,
  [ANCHORAGE_OPTION.CAST_IN_PLACE]: geometryTypeData.anchorageType.castInPlaceOptions,
  [ANCHORAGE_OPTION.ADHESIVE]: geometryTypeData.anchorageType.adhesiveOptions,
  [ANCHORAGE_OPTION.MECHANICAL]: geometryTypeData.anchorageType.mechanicalOptions,
}

export const geometrySubTypeOptions = {
  [MATERIAL_TYPE.CMU]: geometrySubTypeData.materialType.cmuOptions,
  [ANCHORAGE_OPTION.CAST_IN_PLACE]: {
    [GEOMETRY_TYPE.STEMWALL]: geometrySubTypeData.foundationType.stemwallOptions,
    [GEOMETRY_TYPE.TURNED_DOWN_SLAB]: geometrySubTypeData.foundationType.turnedDownSlabOptions,
    [GEOMETRY_TYPE.BRICK_LEDGE]: geometrySubTypeData.foundationType.brickLedgeOptions,
    [GEOMETRY_TYPE.GARAGE_SLAB]: geometrySubTypeData.foundationType.garageSlabOptions,
    [GEOMETRY_TYPE.GARAGE_STEMWALL]: geometrySubTypeData.foundationType.garageStemwallOptions,
  },
  [ANCHORAGE_OPTION.ADHESIVE]: {
    [GEOMETRY_TYPE.ELEVATED_SLAB]:
      geometrySubTypeData.anchorageType.adhesiveAnchors.elevatedSlabOptions,
    [GEOMETRY_TYPE.INTERIOR_THICKENED_FOOTING]:
      geometrySubTypeData.anchorageType.adhesiveAnchors.interiorThickenedFootingOptions,
    [GEOMETRY_TYPE.STEMWALL]: geometrySubTypeData.anchorageType.adhesiveAnchors.stemwallOptions,
    [GEOMETRY_TYPE.TURNED_DOWN_SLAB]:
      geometrySubTypeData.anchorageType.adhesiveAnchors.turnedDownSlabOptions,
    [GEOMETRY_TYPE.BRICK_LEDGE]:
      geometrySubTypeData.anchorageType.adhesiveAnchors.brickLedgeOptions,
  },
  [ANCHORAGE_OPTION.MECHANICAL]: {
    [GEOMETRY_TYPE.ELEVATED_SLAB]:
      geometrySubTypeData.anchorageType.mechanicalAnchors.elevatedSlabOptions,
    [GEOMETRY_TYPE.INTERIOR_THICKENED_FOOTING]:
      geometrySubTypeData.anchorageType.mechanicalAnchors.interiorThickenedFootingOptions,
    [GEOMETRY_TYPE.STEMWALL]: geometrySubTypeData.anchorageType.mechanicalAnchors.stemwallOptions,
    [GEOMETRY_TYPE.TURNED_DOWN_SLAB]:
      geometrySubTypeData.anchorageType.mechanicalAnchors.turnedDownSlabOptions,
    [GEOMETRY_TYPE.BRICK_LEDGE]:
      geometrySubTypeData.anchorageType.mechanicalAnchors.brickLedgeOptions,
  },
}

export const HOLDOWN_SUBTYPE_LABEL = {
  [HOLDOWN_SUBTYPE.EMBEDDED_ANCHOR]: 'Embedded Anchor',
  [HOLDOWN_SUBTYPE.EMBEDDED_STRAP]: 'Embedded Straps',
}

export const PRODUCT_THUMBNAIL_OPTIONS = {
  ABA_Z:
    'https://ssttoolbox.widen.net/content/74tct0gujw/svg/ABA_ProdFamily_Thumbnail.svg?u=gbdlr2',
  ABU_HDG:
    'https://ssttoolbox.widen.net/content/yiogjw3iyt/svg/ABU_ProdFamily_Thumbnail.svg?u=gbdlr2',
  ABU_SS:
    'https://ssttoolbox.widen.net/content/yiogjw3iyt/svg/ABU_ProdFamily_Thumbnail.svg?u=gbdlr2',
  ABU_Z:
    'https://ssttoolbox.widen.net/content/yiogjw3iyt/svg/ABU_ProdFamily_Thumbnail.svg?u=gbdlr2',
  ABW_Z:
    'https://ssttoolbox.widen.net/content/0c8rhecqrq/svg/ABW_ProdFamily_Thumbnail.svg?u=gbdlr2',
  APB_Z_PC:
    'https://ssttoolbox.widen.net/content/39ptyxldck/svg/APB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  APVB_Z_PC:
    'https://ssttoolbox.widen.net/content/czxeozcvki/svg/APVB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  'AT-3G':
    'https://ssttoolbox.widen.net/content/wgrzpbhfl7/svg/AT-3G_ProdFamily_Thumbnail.svg?u=gbdlr2',
  'AT-XP':
    'https://ssttoolbox.widen.net/content/nqepqjvk4e/svg/AT-XP_ProdFamily_Thumbnail.svg?u=gbdlr2',
  BC: 'https://ssttoolbox.widen.net/content/kx6ctj2jl5/svg/BC_ProdFamily_Thumbnail_in.svg?u=gbdlr2',
  BC_PB_SS:
    'https://ssttoolbox.widen.net/content/kx6ctj2jl5/svg/BC_ProdFamily_Thumbnail_in.svg?u=gbdlr2',
  BC_PB_Z:
    'https://ssttoolbox.widen.net/content/kx6ctj2jl5/svg/BC_ProdFamily_Thumbnail_in.svg?u=gbdlr2',
  CB: 'https://ssttoolbox.widen.net/content/rmwrnczfv5/svg/CB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CB_HDG:
    'https://ssttoolbox.widen.net/content/rmwrnczfv5/svg/CB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CB_PC: 'https://ssttoolbox.widen.net/content/rmwrnczfv5/svg/CB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CB_SS: 'https://ssttoolbox.widen.net/content/rmwrnczfv5/svg/CB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBQGT:
    'https://ssttoolbox.widen.net/content/g4ueilo2x5/svg/CBQGT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBQGT_HDG:
    'https://ssttoolbox.widen.net/content/g4ueilo2x5/svg/CBQGT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBS: 'https://ssttoolbox.widen.net/content/ulhirqjcg7/svg/CBS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBS_HDG:
    'https://ssttoolbox.widen.net/content/ulhirqjcg7/svg/CBS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBSQ: 'https://ssttoolbox.widen.net/content/sesbqrsaxa/svg/CBSQ_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBSQ_HDG:
    'https://ssttoolbox.widen.net/content/sesbqrsaxa/svg/CBSQ_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CBSQ_SS:
    'https://ssttoolbox.widen.net/content/sesbqrsaxa/svg/CBSQ_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CPS: 'https://ssttoolbox.widen.net/content/qkdzbmmenm/svg/CPS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CPT_SS:
    'https://ssttoolbox.widen.net/content/bupwpan4ww/svg/CPT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  CPT_Z:
    'https://ssttoolbox.widen.net/content/bupwpan4ww/svg/CPT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  DTT_SS:
    'https://ssttoolbox.widen.net/content/ygxcqrec1g/svg/DTT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  DTT_Z:
    'https://ssttoolbox.widen.net/content/ygxcqrec1g/svg/DTT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  EPB: 'https://ssttoolbox.widen.net/content/bnfwwqcatw/svg/EPB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  'ET-3G':
    'https://ssttoolbox.widen.net/content/siv6vjwzhw/svg/ET-3G_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HBC: 'https://ssttoolbox.widen.net/content/7hpdeh74yi/svg/HBC_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HBC_HDG:
    'https://ssttoolbox.widen.net/content/7hpdeh74yi/svg/HBC_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HD: 'https://ssttoolbox.widen.net/content/kxoati750s/svg/HD_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HDQ: 'https://ssttoolbox.widen.net/content/rsqcydb3t8/svg/HDQ_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HDU: 'https://ssttoolbox.widen.net/content/3ol67bbe4o/svg/HDU_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HDU_HDG:
    'https://ssttoolbox.widen.net/content/3ol67bbe4o/svg/HDU_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HHDQ: 'https://ssttoolbox.widen.net/content/5yofa9w8dq/svg/HHDQ_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HTT: 'https://ssttoolbox.widen.net/content/cxgdig7g5m/svg/HTT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HTTH: 'https://ssttoolbox.widen.net/content/lqlcns4pfg/svg/HTTH_ProdFamily_Thumbnail.svg?u=gbdlr2',
  HTTH_HDG:
    'https://ssttoolbox.widen.net/content/lqlcns4pfg/svg/HTTH_ProdFamily_Thumbnail.svg?u=gbdlr2',
  LSTHD:
    'https://ssttoolbox.widen.net/content/yamtcmnpbp/svg/LSTHD_ProdFamily_Thumbnail.svg?u=gbdlr2',
  LTT: 'https://ssttoolbox.widen.net/content/aamnrklfcs/svg/LTT_ProdFamily_Thumbnail.svg?u=gbdlr2',
  OCB: 'https://ssttoolbox.widen.net/content/dww1hgtfg4/svg/OCB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PAB: 'https://ssttoolbox.widen.net/content/lkqyyipgoa/svg/PAB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PB: 'https://ssttoolbox.widen.net/content/ta1sfzwzii/svg/PB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PB_HDG:
    'https://ssttoolbox.widen.net/content/ta1sfzwzii/svg/PB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PB_Z: 'https://ssttoolbox.widen.net/content/ta1sfzwzii/svg/PB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PBS: 'https://ssttoolbox.widen.net/content/8nyjygfvmi/svg/PBS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PBS_HDG:
    'https://ssttoolbox.widen.net/content/8nyjygfvmi/svg/PBS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PBS_Z:
    'https://ssttoolbox.widen.net/content/8nyjygfvmi/svg/PBS_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PPB_Z:
    'https://ssttoolbox.widen.net/content/05759a4puq/svg/PPB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  PPBF: 'https://ssttoolbox.widen.net/content/nlscukdwd7/svg/PPBF_ProdFamily_Thumbnail0.svg?u=gbdlr2',
  RCP: 'https://ssttoolbox.widen.net/content/nqlvy7xyjg/svg/RCP_ProdFamily_Thumbnail.svg?u=gbdlr2',
  SB: 'https://ssttoolbox.widen.net/content/mvtw5geozn/svg/SB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  'SET-3G':
    'https://ssttoolbox.widen.net/content/69yl5fqa9z/svg/SET-3G_ProdFamily_Thumbnail.svg?u=gbdlr2',
  'SET-XP':
    'https://ssttoolbox.widen.net/content/gul9a4johr/svg/SET-XP_ProdFamily_Thumbnail.svg?u=gbdlr2',
  SSTB: 'https://ssttoolbox.widen.net/content/snipxxrun6/svg/SSTB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  STB2: 'https://ssttoolbox.widen.net/content/kkn8rymtti/svg/STB_ProdFamily_Thumbnail.svg?u=gbdlr2',
  STHD: 'https://ssttoolbox.widen.net/content/gthroawzto/svg/STHD_ProdFamily_Thumbnail.svg?u=gbdlr2',
  Titen_HD:
    'https://ssttoolbox.widen.net/content/th72ibzdsh/svg/Titen_HD_ProdFamily_Thumbnail.svg?u=gbdlr2',
  ECB: 'https://ssttoolbox.widen.net/content/zm4e8ub3bk/svg/ECB_ProdFamily_Thumbnail.svg',
  HDUE: 'https://ssttoolbox.widen.net/content/yxerxsiljc/svg/HDUE_ProdFamily_Thumbnail.svg',
  HDUE_HDG: 'https://ssttoolbox.widen.net/content/yxerxsiljc/svg/HDUE_ProdFamily_Thumbnail.svg',
  CBST_Z: 'https://ssttoolbox.widen.net/content/ygcrbhi8xl/svg/CBST_Z_ProdFamily_Thumbnail.svg',
  CBSTQ_Z: 'https://ssttoolbox.widen.net/content/wxxg9xmhci/svg/CBSTQ_Z_ProdFamily_Thumbnail.svg',
  SABR: 'https://ssttoolbox.widen.net/content/xqmlsmzxlo/svg/SABR_ProdFamily_Thumbnail.svg',
  PBST_Z: 'https://ssttoolbox.widen.net/content/rl02dxyi4j/svg/PBST__ProdFamily_Thumbnail.svg',
  PBST_HDG: 'https://ssttoolbox.widen.net/content/rl02dxyi4j/svg/PBST__ProdFamily_Thumbnail.svg',
  SAGE_B: 'https://ssttoolbox.widen.net/content/npew9s5kqf/svg/SAGEB_ProdFamily_Thumbnail.svg',
  MPB_Z: 'https://ssttoolbox.widen.net/content/7gsiwh3l5d/svg/MPBZ_ProdFamily_Thumbnail.svg',
}

export const PRODUCT_LINK_OPTIONS = {
  ABA_Z: 'https://www.strongtie.com/retrofitpostbases_postbases/aba_base/p/aba',
  ABU_HDG: 'https://www.strongtie.com/retrofitpostbases_postbases/abu_base/p/abu',
  ABU_SS: 'https://www.strongtie.com/retrofitpostbases_postbases/abu_base/p/abu',
  ABU_Z: 'https://www.strongtie.com/retrofitpostbases_postbases/abu_base/p/abu',
  ABW_Z: 'https://www.strongtie.com/retrofitpostbases_postbases/abw_base/p/abw',
  APB_Z_PC: 'https://www.strongtie.com/missioncollection_outdooraccents/apb_base/p/apb',
  APVB_Z_PC: 'https://www.strongtie.com/avantcollection_outdooraccents/apvb_base/p/apvb',
  'AT-3G': 'https://www.strongtie.com/acrylicanchoringadhesives_adhesives/at-3g_adhesive/p/at-3g',
  'AT-XP': 'https://www.strongtie.com/acrylicanchoringadhesives_adhesives/at-xp_adhesive/p/at-xp',
  BC: 'https://www.strongtie.com/postbases_capsandbases/bc_base/p/bc',
  BC_PB_SS: 'https://www.strongtie.com/postbases_capsandbases/bc_base/p/bc',
  BC_PB_Z: 'https://www.strongtie.com/postbases_capsandbases/bc_base/p/bc',
  CB: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cb_base/p/cb',
  CB_HDG: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cb_base/p/cb',
  CB_PC: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cb_base/p/cb',
  CB_SS: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cb_base/p/cb',
  CBQGT: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cbqgt_base/p/cbqgt',
  CBQGT_HDG: 'https://www.strongtie.com/nonstandoffcolumnbases_columnbases/cbqgt_base/p/cbqgt',
  CBS: 'https://www.strongtie.com/standoffcolumnbases_columnbases/cbs_base/p/cbs',
  CBS_HDG: 'https://www.strongtie.com/standoffcolumnbases_columnbases/cbs_base/p/cbs',
  CBSQ: 'https://www.strongtie.com/standoffcolumnbases_columnbases/cbsq_base/p/cbsq',
  CBSQ_HDG: 'https://www.strongtie.com/standoffcolumnbases_columnbases/cbsq_base/p/cbsq',
  CBSQ_SS: 'https://www.strongtie.com/standoffcolumnbases_columnbases/cbsq_base/p/cbsq',
  CPS: 'https://www.strongtie.com/specialtycollection_architecturalproductsgroup/cps_base/p/cps',
  CPT_SS: 'https://www.strongtie.com/retrofitpostbases_postbases/cptz_base/p/cptz',
  CPT_Z: 'https://www.strongtie.com/retrofitpostbases_postbases/cptz_base/p/cptz',
  DTT_SS: 'https://www.strongtie.com/decks_decksandfences/dtt_tie/p/dtt',
  DTT_Z: 'https://www.strongtie.com/decks_decksandfences/dtt_tie/p/dtt',
  EPB: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/epb_base/p/epb',
  'ET-3G': 'https://www.strongtie.com/epoxyanchoringadhesives_adhesives/et-3g_adhesive/p/et-3g',
  HBC: 'https://www.strongtie.com/postbases_capsandbases/hbc_base/p/hbc',
  HBC_HDG: 'https://www.strongtie.com/postbases_capsandbases/hbc_base/p/hbc',
  HD: 'https://www.strongtie.com/boltedholdowns_holdowns/hd_holdown/p/hd',
  HDQ: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hdq_holdown/p/hdq',
  HDU: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hdu_holdown/p/hdu',
  HDU_HDG: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hdu_holdown/p/hdu',
  HHDQ: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hhdq_holdown/p/hhdq',
  HTT: 'https://www.strongtie.com/tensionties_holdownsandtensionties/htt_tie/p/htt.htth',
  HTTH: 'https://www.strongtie.com/tensionties_holdownsandtensionties/htt_tie/p/htt.htth',
  HTTH_HDG: 'https://www.strongtie.com/tensionties_holdownsandtensionties/htt_tie/p/htt.htth',
  LSTHD: 'https://www.strongtie.com/straptieholdowns_holdownsandtensionties/lsthd_holdown/p/lsthd',
  LTT: 'https://www.strongtie.com/tensionties_holdownsandtensionties/ltt_tie/p/ltt',
  OCB: 'https://www.strongtie.com/rusticcollection_architecturalproductsgroup/ocb_base/p/ocb',
  PAB: 'https://www.strongtie.com/bolts_anchorbolts/pab_bolt/p/pab',
  PB: 'https://www.strongtie.com/nonstandoffpostbases_postbases/pb_base/p/pb',
  PB_HDG: 'https://www.strongtie.com/nonstandoffpostbases_postbases/pb_base/p/pb',
  PB_Z: 'https://www.strongtie.com/nonstandoffpostbases_postbases/pb_base/p/pb',
  PBS: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/pbs_base/p/pbs',
  PBS_HDG: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/pbs_base/p/pbs',
  PBS_Z: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/pbs_base/p/pbs',
  PPB_Z: 'https://www.strongtie.com/nonstandoffpostbases_postbases/ppbz_base/p/ppbz',
  PPBF: 'https://www.strongtie.com/nonstandoffpostbases_postbases/ppbf_base/p/ppbf',
  RCP: 'https://www.strongtie.com/nonstandoffpostbases_postbases/rcps_saddle/p/rcps',
  SB: 'https://www.strongtie.com/bolts_anchorbolts/sb_bolt/p/sb',
  'SET-3G': 'https://www.strongtie.com/epoxyanchoringadhesives_adhesives/set-3g_adhesive/p/set-3g',
  'SET-XP': 'https://www.strongtie.com/epoxyanchoringadhesives_adhesives/set-xp_adhesive/p/set-xp',
  SSTB: 'https://www.strongtie.com/bolts_anchorbolts/sstb_bolt/p/sstb',
  STB2: 'https://www.strongtie.com/mechanicalanchors_mechanicalanchoringproducts/stb2_anchor/p/strong-bolt-2',
  STHD: 'https://www.strongtie.com/straptieholdowns_holdownsandtensionties/sthd_holdown/p/sthd',
  Titen_HD:
    'https://www.strongtie.com/mechanicalanchors_mechanicalanchoringproducts/thd_anchor/p/titen-hd',
  ECB: 'https://www.strongtie.com/standoffcolumnbases_columnbases/ecb_base/p/ecb?_br_psugg_q=ecb66',
  HDUE: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hdue_holdown/p/hdue',
  HDUE_HDG: 'https://www.strongtie.com/sdsscrewholdowns_holdowns/hdue_holdown/p/hdue',
  CBST_Z: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/cbst_base/p/cbst',
  CBSTQ_Z: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/cbstq_base/p/cbstq',
  SABR: 'https://www.strongtie.com/bolts_anchorbolts/sabr_bolt/p/sabr',
  PBST_Z: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/pbst_base/p/pbst',
  PBST_HDG: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/pbst_base/p/pbst',
  SAGE_B: 'https://www.strongtie.com/sage_outdooraccents/sage-b_base/p/sage-b',
  MPB_Z: 'https://www.strongtie.com/standoffpostbases_castinplacepostbases/mpb_base/p/mpbz',
  // Fallback
  default: '#',
}

export const POST_BASE_LABELS = { [COUNTRY.USA]: 'Post & Post Base', [COUNTRY.CANADA]: 'Post Base' }

export const HOLDOWN_LABELS = { [COUNTRY.USA]: 'Post & Holdown', [COUNTRY.CANADA]: 'Holdown' }

export const BUILDING_CODE = {
  [COUNTRY.USA]: '22',
  [COUNTRY.CANADA]: '41',
}

export const FOUNDATION_TYPE = {
  CONCRETE_2175: '0',
  CONCRETE_2500: '1',
  CONCRETE_2900: '2',
  WOOD: '3',
}

export const UPLIFT_DURATION = {
  SHORT: '115',
  STANDARD: '100',
}

export const LOAD_TYPE_CANADA = [
  {
    text: 'Wind & IEFaSa(0.2) < 0.35, Cracked',
    value: '0',
    content: (
      <span>
        Wind & I<sub>E</sub>F<sub>a</sub>S<sub>a</sub>(0.2) &lt; 0.35, Cracked
      </span>
    ),
  },
  {
    text: 'Wind & IEFaSa(0.2) < 0.35, Uncracked',
    value: '1',
    content: (
      <span>
        Wind & I<sub>E</sub>F<sub>a</sub>S<sub>a</sub>(0.2) &lt; 0.35, Uncracked
      </span>
    ),
  },
  {
    text: 'Seismic IEFaSa(0.2) ≥ 0.35, Cracked',
    value: '2',
    content: (
      <span>
        Seismic & I<sub>E</sub>F<sub>a</sub>S<sub>a</sub>(0.2) &ge; 0.35, Cracked
      </span>
    ),
  },
  {
    text: 'Seismic IEFaSa(0.2) ≥ 0.35, Uncracked',
    value: '3',
    content: (
      <span>
        Seismic & I<sub>E</sub>F<sub>a</sub>S<sub>a</sub>(0.2) &ge; 0.35, Uncracked
      </span>
    ),
  },
]

export const HELP_IMG = {
  [POST_BASE_SUBTYPE.POST_INSTALLED]: {
    [POST_BASE_MATERIAL_TYPE.WOOD]: {
      LATERAL_F1: 'https://ssttoolbox.widen.net/content/szlswcfvzp/svg/F1_Post_installed_Wood.svg',
    },
    [POST_BASE_MATERIAL_TYPE.CONCRETE]: {
      LATERAL_F1:
        'https://ssttoolbox.widen.net/content/kp7i5s3djt/svg/F1F2_Post_installed_Concrete.svg',
      LATERAL_F2:
        'https://ssttoolbox.widen.net/content/kp7i5s3djt/svg/F1F2_Post_installed_Concrete.svg',
    },
  },
  [POST_BASE_SUBTYPE.CAST_IN_PLACE]: {
    LATERAL_F1: 'https://ssttoolbox.widen.net/content/k2vxtd2edz/svg/F1F2_Cast_in_place.svg',
    LATERAL_F2: 'https://ssttoolbox.widen.net/content/k2vxtd2edz/svg/F1F2_Cast_in_place.svg',
  },
  CANADA_F1_F2: {
    [FOUNDATION_TYPE.WOOD]:
      'https://ssttoolbox.widen.net/content/szlswcfvzp/svg/F1_Post_installed_Wood.svg',
    [FOUNDATION_TYPE.CONCRETE_2175]:
      'https://ssttoolbox.widen.net/content/kp7i5s3djt/svg/F1F2_Post_installed_Concrete.svg',
    [FOUNDATION_TYPE.CONCRETE_2500]:
      'https://ssttoolbox.widen.net/content/kp7i5s3djt/svg/F1F2_Post_installed_Concrete.svg',
    [FOUNDATION_TYPE.CONCRETE_2900]:
      'https://ssttoolbox.widen.net/content/kp7i5s3djt/svg/F1F2_Post_installed_Concrete.svg',
  },
  POST_WIDTH_POST_THICKNESS:
    'https://ssttoolbox.widen.net/content/mecqr7ort3/svg/PFD_STEMWALL_W1_W2.svg',
}

export const DOWNLOAD_DURATION = {
  STANDARD: '100',
}

export const MIN_STEMWALL_THICKNESS_INITIAL_STATE = '8'

export const POST_WIDTH_HOLDOWN_DEFAULT = '3.5'

export const POST_WIDTH_POST_BASE_DEFAULT = '4'

export const POST_THICKNESS_HOLDOWN_DEFAULT = '3.5'

export const POST_THICKNESS_POST_BASE_DEFAULT = '4'

export const POST_WIDTH_INITIAL_STATE =
  postWidthData.holdown.lumberSpecies.douglasFirLarchOptions.find((item) => item.default)?.value ||
  POST_WIDTH_HOLDOWN_DEFAULT

export const POST_THICKNESS_INITIAL_STATE =
  postThicknessData.holdown.lumberSpecies.douglasFirLarchOptions.find((item) => item.default)
    ?.value || POST_THICKNESS_HOLDOWN_DEFAULT

export const INSTALLATION_TYPE = {
  CORNER_WALL: '0',
  END_OF_WALL: '1',
  MID_WALL: '2',
}

export const SETTINGS_INITIAL_STATE = {
  country: COUNTRY.USA,
  isUSA: true,
  buildingCode: BUILDING_CODE[COUNTRY.USA],
}

export const HIDDEN_FIELD_VALUE = -1

export const POST_BASE_DEFAULT_STATE = {
  postBaseDesign: false,
  downloadASD: '0',
  upliftLoadASD: '0',
  lateralF1: '0',
  lateralF2: '0',
  postBaseSubType: POST_BASE_SUBTYPE.POST_INSTALLED,
  postBaseLumberSpecies: POST_BASE_LUMBER_SPECIES[COUNTRY.USA].DOUGLAS_FIR_LARCH,
  postBaseGeometryType: POST_BASE_GEOMETRY_TYPE.STEMWALL,
  postBaseGeometrySubType: POST_BASE_GEOMETRY_SUBTYPE.MID_WALL_ANCHOR,
  postBaseMaterialType: POST_BASE_MATERIAL_TYPE.CONCRETE,
  postBaseLoadType: POST_BASE_LOAD_TYPE.WIND_AND_SDC_AB,
  corrosionResistance: [CORROSION_RESISTANCE_VALUE.ALL],
  validation: {},
  postBaseType: POST_BASE_TYPE.POST_INSTALLED,
  foundationType: FOUNDATION_TYPE.CONCRETE_2500,
  upliftDuration: UPLIFT_DURATION.SHORT,
  factoredUpliftLRFD: '0',
  factoredDownloadLRFD: '0',
  minStemwallThickness: MIN_STEMWALL_THICKNESS_INITIAL_STATE,
  downloadDuration: DOWNLOAD_DURATION.STANDARD,
  postWidth: POST_WIDTH_INITIAL_STATE,
  postThickness: POST_THICKNESS_INITIAL_STATE,
}

export const UNITS = {
  LSD: 'LSD',
}

export const POST_BASE_TYPE_IMG_SRC = {
  [POST_BASE_TYPE.POST_INSTALLED]:
    'https://ssttoolbox.widen.net/content/rqvityn9vq/svg/PFD_PB_PostInstalled.svg',
  [POST_BASE_TYPE.CAST_IN_PLACE]:
    'https://ssttoolbox.widen.net/content/2synutkutr/svg/PFD_PB_CastInPlace_CBS.svg',
}

export const HOLD_DOWN_TYPE_IMG_SRC = {
  [POST_BASE_TYPE.POST_INSTALLED]:
    'https://embed.widencdn.net/svg/ssttoolbox/inscbvdyhz/C_HDU5_InstIll_Ill_Instld_CN.svg?u=oviqdm',
  [POST_BASE_TYPE.CAST_IN_PLACE]:
    'https://embed.widencdn.net/svg/ssttoolbox/kx7kwhupce/STHD_midwall_in.svg',
}

export const FASTENERS_FAMILY_PRODUCT_LINK = {
  '10d-CN_SM_BRT':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '10d-CN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '10d-CTRN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '16d-CN_SM_316SS':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '16d-CN_SM_BRT':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '16d-CN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '4d-CN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '4d-CTRN_SM_BRT':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '8d-CN_SM_BRT':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  '8d-CN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  SD: 'https://www.strongtie.com/strongdrive_exteriorwoodscrews/sd_screw/p/strong-drive-sd-connector-screw',
  SDS: 'https://www.strongtie.com/strongdrive_exteriorwoodscrews/sds_screw/p/strong-drive-sds-heavy-duty-connector-screw',
  SDS_HDG:
    'https://www.strongtie.com/strongdrive_exteriorwoodscrews/sds_screw/p/strong-drive-sds-heavy-duty-connector-screw',
  SDS_SS:
    'https://www.strongtie.com/strongdrive_exteriorwoodscrews/sds_screw/p/strong-drive-sds-heavy-duty-connector-screw',
  SDWS_DBB:
    'https://www.strongtie.com/essentials_outdooraccents/sdws-dbb_screw/p/outdoor-accents-structural-wood-screw',
  '16d-SKN_SM_HDG':
    'https://www.strongtie.com/strongdrive_exteriornails/scn_nail/p/strong-drive-scn-smooth-shank-connector-nail',
  STN: 'https://www.strongtie.com/essentials_outdooraccents/sdws-dbb_screw/p/outdoor-accents-structural-wood-screw',
  SD_DB:
    'https://www.strongtie.com/essentials_outdooraccents/sd-dbb_screw/p/outdoor-accents-connector-screw',
  SD_SS:
    'https://www.strongtie.com/strongdrive_exteriorwoodscrews/sd-ss_screw/p/strong-drive-sd-connector-ss-screw',
  // Fallback
  default: '#',
}
